<a routerLink="/testing/playground" routerLinkActive="ngActiveLinkWhite" ariaCurrentWhenActive="page" class="menuLeftItem" (click)="session.testingOnClick()">Playground</a>
<!--  -->
<a routerLink="/testing/modal-flex" routerLinkActive="ngActiveLinkWhite" ariaCurrentWhenActive="page" class="menuLeftItem" (click)="session.testingOnClick()">Modal-Flex</a>
<!--  -->
<a routerLink="/testing/modal-grid" routerLinkActive="ngActiveLinkWhite" ariaCurrentWhenActive="page" class="menuLeftItem" (click)="session.testingOnClick()">Modal-Grid</a>
<!--  -->
<button class="menuLeftItem" (click)="triggerWhirlySpinner()">Whirly Spinner Test</button>
